// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"13e5960f","809":"5b4bea51"}[chunkId] + ".chunk.js";
};